import React, { useContext, useEffect, useState } from "react";
import CloseButton from "../../closeButton/CloseButton";
import { modalStyles } from "../../../theme/theme";
import { SearchBar } from "../../searchBar/SearchBar";
import { sortListComponent } from "../../../theme/theme";
import ProductList from "../../listComponents/productList/ProductList";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../services/firebaseConfig";
import { AuthContext } from "../../../services/context/authContext/AuthContext";

const AddProductModal = ({
  toggle,
  title,
  modalVisible,
  addProductToOrderHandler,
}) => {
  const sortList = [
    "SE - Shaker Espresso",
    "SW - Shaker White",
    "GR - Shaker Gray",
    "SNB - Shaker Navy Blue",
    "AE - Autumn Elm",
    "CS - Charleston Saddle",
    "CW - Charleston White",
    "AC - Aspen Charcoal",
    "AW - Aspen White",
  ];
  const user = useContext(AuthContext);

  const [input, setInput] = useState("");
  const [products, setProducts] = useState([]);
  const [productListDefault, setProductListDefault] = useState([]);

  const [sortItem, setSortItem] = useState(sortList[0]);

  useEffect(() => {
    let isMounted = true;
    const discount = user?.discount;

    const fetchProducts = async () => {
      const productList = [];
      const q = query(
        collection(db, "products"),
        where("type", "==", sortItem)
      );
      const data = await getDocs(q);

      if (!data.empty)
        data.forEach((product) => {
          const prod = product.data();
          if (discount) {
            prod.price = prod.price - (prod.price * discount) / 100;
          }
          productList.push(prod);
        });

      if (isMounted) {
        setProducts(productList);
        setProductListDefault(productList);
      }
    };
    fetchProducts().catch((err) => console.log(err));
    return () => {
      isMounted = false;
    };
  }, [user, sortItem]);

  const updateInput = async (input) => {
    const filtered = productListDefault
      .filter((product) => {
        if (
          product.sku.toLowerCase().startsWith(input.toLowerCase()) ||
          product.name.toLowerCase().includes(input.toLowerCase()) ||
          product.category.toLowerCase().startsWith(input.toLowerCase()) ||
          product.subcategory.toLowerCase().startsWith(input.toLowerCase()) ||
          product.type.toLowerCase().startsWith(input.toLowerCase())
        ) {
          return product;
        }
        return null;
      })
      .sort((a, b) => a.sku.localeCompare(b.sku));
    setInput(input);
    setProducts(filtered);
  };
  //1090
  return (
    <div
      className={
        modalVisible ? modalStyles["overlayShow"] : modalStyles["overlayHide"]
      }
    >
      <div
        className={`${"min-h-modal-mobile tablet:min-h-modal-h "} [width:1200px]  mx-5 z-50 relative  my-auto  tablet:mx-auto min-w-57rem  flex flex-col bg-white rounded-32`}
        style={{ height: "calc(100vh - 100px)" }}
      >
        <div className=" [min-height:99px] rounded-t-32  px-14 bg-primary flex flex-col items-start justify-center relative ">
          <h2 className="font-bold text-lg desktop:text-2xl text-white">
            {title}
          </h2>
          <CloseButton
            className=" top:7 right-7 absolute"
            currentColor="white"
            onClick={toggle}
          />
        </div>
        <div className="pt-10 pb-12 px-5 tablet:px-10 flex flex-col  overflow-scroll ">
          <div className={"flex flex-col gap-6 mb-14 w-full"}>
            <div className="flex flex-col gap-6 [height:196px] ">
              <div className="flex flex-col  mx-0 flex-wrap tablet:mx-0  tablet:flex-row gap-5  tablet:items-center ">
                <div className="flex center items-center flex-wrap [gap:6px]">
                  <h3 className="text-left w-16 tablet:text-center">
                    {"Colors"}
                  </h3>

                  {sortList.map((listItem) => {
                    return (
                      <div
                        key={listItem}
                        className={
                          listItem === sortItem
                            ? sortListComponent["selectedColorItem"]
                            : sortListComponent["ColorItem"]
                        }
                        onClick={() => setSortItem(listItem)}
                      >
                        {listItem}
                      </div>
                    );
                  })}
                </div>
              </div>
              <SearchBar
                keyword={input}
                setKeyword={updateInput}
                className="border-solid border border-gray-300 rounded-2xl"
              />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center">
            {products.length ? (
              <ProductList
                products={products}
                setProducts={setProducts}
                className="tablet:w-full flex flex-col gap-8  "
                addProductToOrderHandler={addProductToOrderHandler}
              />
            ) : (
              <div className="font-bold text-txtBlack mt-10">
                No products found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductModal;
